import { KeyValuePair } from '@common/data-models/misc/key-value-pair';
import { AbstractServiceRecord } from '@common/data-models/service/abstract-service-record';
import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';

let metaData = {
    Actual: DataType.OBJECT,
    Estimated: DataType.STRING,
    HardHitBack: DataType.DATE,
    HardHitFront: DataType.DATE,
    ReadTime: DataType.NUMBER
};

KnownPropertyTypes.setFor(metaData);

export class ServiceRecord extends AbstractServiceRecord {
    public Actual?: any;
    public ActualTimeString?: KeyValuePair<string, string>;
    public Estimated?: string;
    public HardHitBack?: string;
    public HardHitFront?: string;
    public ReadTime?: number;

    public getOwnMetaData(): { [id: string]: number } {
        let objectKeys = Object.keys(this);
        let ret = {};
        for (let prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return (ret);
    }

    public getMetaData(): { [id: string]: number } {
        let ret = this.getOwnMetaData();
        let parentMetaData = super.getMetaData();

        // merge
        for (let p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        } else return super.getRawValue(field);
    }

    public static instance(data: any): ServiceRecord {
        let ret: ServiceRecord = Object.assign(new ServiceRecord, data);
        ret.instantiateChildren();
        return ret;
    }
}
